import FormHead from "../RecordPage/FormHead";
import { useState, useRef, useEffect } from "react";
import { GetSearchData, SendEyeRecord } from "./FetchData";
import { getToday } from "../RecordPage/GetToday";
import AddPDF from "./AddPDF";
import { toast } from "react-toastify";

const testList=['VA', 'VACC', 'S', 'C', 'A', 'AL', 'ACD', 'LT', 'CCT', 'WTW', 'Pupil', 'Kappa', 'angle', 'ART', 'CD', 'VFI', 'MD30', 'MD24', 'MD24c', 'MD10', 'CAT', 'iop_records'];
const testText = {VA:"VA", VACC:"VACC", S:"S", C:"C", A:"A", IOP:"IOP", AL:"AL", ACD:"ACD", LT:"LT", CCT:"CCT", WTW:"WTW", Pupil:"Pupil", Kappa:"Kappa", angle:"Kappa軸度", ART:"Average RNFL Thickness", CD:"Average C/D Ratio", MD:"MD30-2", CAT:"Cube Thickness Average"};
const initialRecord = {isNewRecord: true, ACD_OD: null, ACD_OS: null, AL_OD: null, AL_OS: null, ART_OD: null, ART_OS: null, A_OD: null, A_OS: null, CAT_OD: null, CAT_OS: null, CCT_OD: null, CCT_OS: null, CD_OD: null, CD_OS: null, C_OD: null, C_OS: null, Kappa_OD: null, Kappa_OS: null, LT_OD: null, LT_OS: null, MD10_OD: null, MD10_OS: null, MD24_OD: null, MD24_OS: null, MD24c_OD: null, MD24c_OS: null, MD30_OD: null, MD30_OS: null, Pupil_OD: null, Pupil_OS: null, S_OD: null, S_OS: null, VACC_OD: null, VACC_OS: null, VA_OD: null, VA_OS: null, VFI_OD: null, VFI_OS: null, WTW_OD: null, WTW_OS: null, angle_OD: null, angle_OS: null, iop_records:[]}
const today = getToday();

function AddExamineRecord({patientData}){
    const [originRecord, setOriginRecord] = useState({});
    const [webpageRecord, setWebpageRecord] = useState({});
    const [recordDates, setRecordDates] = useState([]);
    const [outletDatas, setOutletDatas] = useState({});
    const [deleteIOPList, setDeleteIOPList] = useState([]);
    const [lastDate, setLastDate] = useState(null);
    const [sendOnClick, setSendOnClick] = useState(false);

    const dateRef = useRef(null);
    const dateInputRef = useRef(null);

    const PDFRef = useRef({});

    const pushNewIOP = () => {
        setOutletDatas(prevState => (
            {
                ...prevState,
                iop_records : [...prevState.iop_records, {test_time: null, IOP_OD: null, IOP_OS: null, record_id: null, eye_record_record_id: null}]
            }
        ))
    }

    const deleteIOP = (indexToDelete) => {
        const updatedItems = outletDatas.iop_records.filter((item, index) => index !== indexToDelete);
        setOutletDatas(prevState => (
            {
                ...prevState,
                iop_records: updatedItems
            }
        ));
        if(outletDatas.iop_records[indexToDelete].record_id && outletDatas.iop_records[indexToDelete].record_id!=='' ){
            if(!deleteIOPList.includes(outletDatas.iop_records[indexToDelete].record_id))setDeleteIOPList([...deleteIOPList, outletDatas.iop_records[indexToDelete].record_id])
        }
    }

    const addNewDate = (newDate) => {
        if(!recordDates.includes(newDate))setRecordDates([...recordDates, newDate]);
        if(!webpageRecord.hasOwnProperty(newDate)){
            setWebpageRecord(prevState => (
                {
                    ...prevState,
                    [newDate]: initialRecord
                }
            ))
        }
    }

    const changeDate = async(newDate) => {
        await PDFRef.current.storeNow();
        await updateWebpageData(outletDatas);
        setOutletDatas(webpageRecord[newDate])
        if(webpageRecord.PDFUpdateList && webpageRecord.PDFUpdateList[newDate]){
            PDFRef.current.setPDFFromRecord(webpageRecord.PDFUpdateList[newDate]);
        }
        else{
            PDFRef.current.setPDFFromRecord({});
        }
        // setDeleteIOPList((webpageRecord.deleteIOPList) ? webpageRecord.deleteIOPList : [])
    }

    const updateOutlet = (item, value, index) => {
        if(item.includes("IOP") || item==="test_time"){
            let temArray = outletDatas.iop_records ? outletDatas.iop_records : [];
            temArray[index][item] = value==='' ? null : value;
            setOutletDatas(prevState => (
                {
                    ...prevState,
                    iop_records: temArray
                }
            ))
        }
        else{
            setOutletDatas(prevState => (
                {
                    ...prevState,
                    [item]: value==='' ? null : value
                }
            ))
        }
        // console.log(outletDatas)
        // console.log("web",webpageRecord[dateRef.current.value].iop_records)
        // console.log("origin",originRecord[dateRef.current.value].iop_records)
    }

    const updateWebpageData = async(dataInput) => {
        const PDFList = PDFRef.current.getPDF();

        // console.log(lastDate)
        if(Object.keys(dataInput).length===0){
            console.log(dataInput)
            let temDeleteList = webpageRecord.deleteRecordList ? webpageRecord.deleteRecordList : [];
            temDeleteList.push(originRecord[lastDate].record_id)
            setWebpageRecord(prevState => ({
                ...prevState, 
                [lastDate]: dataInput,
                deleteIOPList: deleteIOPList,
                deleteRecordList: temDeleteList,
            }))
        }
        else if(originRecord[lastDate]){
            let temUpdateList = {};
            Object.entries(dataInput).forEach(([item, value]) => {
                if(item!=="iop_records"){
                    if(dataInput[item] !== originRecord[lastDate][item]){
                        temUpdateList[item] = value
                    }
                }
                else{
                    let temUpdateList_IOP = {};
                    dataInput.iop_records.forEach((record, index) => {
                        if(!record.record_id){
                            let temRecord = record;
                            temUpdateList_IOP[index] = temRecord;
                        }
                        else{
                            Object.entries(record).forEach(([item, value]) => {
                                let temIndex = index;
                                while(deleteIOPList.includes(originRecord[lastDate]["iop_records"][temIndex].record_id))temIndex++;
                                // console.log(value, originRecord[lastDate]["iop_records"][index][item])
                                if(value !== originRecord[lastDate]["iop_records"][temIndex][item]){
                                    if(temUpdateList_IOP[index]){temUpdateList_IOP[index][item] = value}
                                    else{temUpdateList_IOP[index] = {[item]: value}}
                                    temUpdateList_IOP[index].record_id = record.record_id;
                                }
                            })
                        }
                    })
                    // console.log("IOP",temUpdateList_IOP)
                    if(Object.keys(temUpdateList_IOP).length>0){temUpdateList.IOP = temUpdateList_IOP}
                }
            })
            if(Object.keys(temUpdateList).length>0)temUpdateList.record_id = dataInput.record_id;
            console.log(temUpdateList)
            setWebpageRecord(prevState => ({
                ...prevState, 
                [lastDate]: dataInput,
                updateList: {
                    ...prevState.updateList,
                    [lastDate]: temUpdateList
                },
                deleteIOPList: deleteIOPList,
                PDFUpdateList: {
                    ...prevState.PDFUpdateList,
                    [lastDate]: PDFList
                }
            }))
        }
        else{   
            setWebpageRecord(prevState => ({
                ...prevState, 
                [lastDate]: dataInput,
                updateList: {
                    ...prevState.updateList,
                    [lastDate]: {isNewRecord: true, record_id: null}
                },
                deleteIOPList: deleteIOPList,
                PDFUpdateList: {
                    ...prevState.PDFUpdateList,
                    [lastDate]: PDFList
                }
            }))
        }
    }

    const deleteToday = () => {
        let temData = outletDatas.iop_records;
        let record_id = outletDatas.record_id
        console.log(temData)
        if(temData && temData.length>0){
            let temDeleteList = deleteIOPList;
            temData.forEach(record => {
                if(!record.record_id || record.record_id === '')return;
                if(!deleteIOPList.includes(record.record_id))temDeleteList.push(record.record_id)
            })
            setDeleteIOPList(temDeleteList)
        }
        let newRecord = initialRecord;
        newRecord.record_id = record_id;
        setOutletDatas(initialRecord)

        if(record_id){PDFRef.current.clearPDF(record_id)}
        //make an alert
        toast.warn('請確保PDF全部刪除再按保存')
    }

    const recoverToday = () => {
        if(originRecord[dateRef.current.value]){
            let recoveredDeleteIOPList = deleteIOPList;
            originRecord[dateRef.current.value].iop_records.forEach(record => {
                if(deleteIOPList.includes(record.record_id)){
                    recoveredDeleteIOPList.splice(recoveredDeleteIOPList.indexOf(record.record_id),1)
                }
            })
            let recoveredRecordList = (webpageRecord.deleteRecordList) ? webpageRecord.deleteRecordList.filter((id) => id!==originRecord[dateRef.current.value].record_id) : []
            setWebpageRecord(prevState => (
                {
                    ...prevState,
                    [dateRef.current.value]: JSON.parse(JSON.stringify(originRecord[dateRef.current.value])),
                    deleteIOPList: recoveredDeleteIOPList,
                    deleteRecordList: recoveredRecordList,
                    updateList: {
                        ...prevState.updateList,
                        [dateRef.current.value]: {}
                    },
                }
            ))
            //recover PDF
            PDFRef.current.recoverPDF();
        }
        else{
            setWebpageRecord(prevState => (
                {
                    ...prevState,
                    [dateRef.current.value]: JSON.parse(JSON.stringify(initialRecord)),
                    updateList: {
                        ...prevState.updateList,
                        [dateRef.current.value]: {}
                    },
                }
            ))
        }
    }

    const displayRecord = (inputRecord) => {
        return (
            <>
                {testList.map((key) => (
                    key==="iop_records" ? (
                        <>
                            <tr>
                                <td ></td>
                                <td>
                                    <div className=" text-nowrap">
                                        {"IOP"} 
                                        <button className="py-1 px-2 bg-[#0000] text-[#2a78a5] text-3xl" style={{borderRadius:".5em"}} onClick={() => pushNewIOP()}>+</button>
                                    </div>
                                </td>
                            </tr>
                            <tr className="text-center bg-[#95ff95]">
                                <td className="w-1/12 bg-[#D9EFEC] py-6"></td>
                                <td className="rounded-l-lg">測驗項目</td>
                                <td className="px-4 py-2">OD</td>
                                <td className="px-4 py-2 rounded-r-lg">OS</td>
                            </tr>
                            {
                                inputRecord.iop_records.map((record, index) => (
                                    <tr>
                                        <td ></td>
                                        <td className="w-1/4"><input type="time" className=" border rounded-md px-2" value={record.test_time} onChange={(event) => updateOutlet("test_time", event.target.value, index)}></input></td>
                                        <td className="w-1/4"><input type="number" step="0.01" className=" border rounded-md px-2" value={record["IOP_OD"] ? record["IOP_OD"] : ''} onChange={(event) => updateOutlet("IOP_OD", parseFloat(event.target.value), index)}></input></td>
                                        <td className="w-1/4">
                                            <div className=" text-nowrap">
                                                <input type="number" step="0.01" className=" border rounded-md px-2" value={record["IOP_OS"] ? record["IOP_OS"] : ''} onChange={(event) => updateOutlet("IOP_OS", parseFloat(event.target.value), index)}></input>
                                                <button className="ml-4 bg-[#0000] text-[#2a78a5] text-3xl" style={{borderRadius:".5em"}} onClick={(event) => deleteIOP(index)}>-</button>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            }
                        </>
                    ) : 
                    (
                        <tr>
                            <td ></td>
                            <td className="w-1/3">{testText[key] ? testText[key] : key}</td>
                            <td className="px-4 py-2 w-1/3"><input type="text" className=" border rounded-md px-2" value={inputRecord[key+"_OD"] ? inputRecord[key+"_OD"] : ''} onChange={(event) => updateOutlet(key+"_OD", event.target.value)}></input></td>
                            <td className="px-4 py-2 w-1/3"><input type="text" className=" border rounded-md px-2" value={inputRecord[key+"_OS"] ? inputRecord[key+"_OS"] : ''} onChange={(event) => updateOutlet(key+"_OS", event.target.value)}></input></td>
                        </tr>
                    )
                ))}
            </>
        )
    }

    const sendDataToServer = async () => {
        await PDFRef.current.storeNow()
        await updateWebpageData(outletDatas);
        setSendOnClick(true);
    }

    let returnValue = GetSearchData("eye_record/"+patientData.client_data_record_id);

    useEffect(() => {
        if(Array.isArray(returnValue)){
            console.log(returnValue)
            try{
                let temRecords = {};
                let temDate = [];
                returnValue.forEach((record) => {
                    temDate.push(record.test_date);
                    temRecords[record.test_date] = record;
                })
                setOriginRecord(JSON.parse(JSON.stringify(temRecords)));
                setWebpageRecord(JSON.parse(JSON.stringify(temRecords)));
                setRecordDates(temDate);
            }
            catch(error){
                console.log("error:",error)
            }
        }
    }, [returnValue])

    useEffect(() => {
        try{
            console.log("fetch:", webpageRecord)
            // console.log("origin", originRecord)
            // deep copy
            setOutletDatas(JSON.parse(JSON.stringify(webpageRecord[dateRef.current.value])))
            setLastDate(dateRef.current.value)
        }
        catch(error){
            console.log("error:", error)
        }
    }, [webpageRecord, dateRef])

    useEffect(() => {
        if(sendOnClick){
            SendEyeRecord(webpageRecord, patientData.client_data_record_id)
            setSendOnClick(false);
        }
    }, [sendOnClick])

    return(
        <div className="text-xl">
            {webpageRecord.length===0 ? <div>loading...</div> : 
                <>
                    <table name="FormHeadExtend" className="m-auto ">
                        <tr><FormHead patient_name={patientData.name}></FormHead></tr>
                        <tr>
                            <td>
                                <div className="flex align-middle">
                                    檢查日期：
                                    <select ref={dateRef} onChange={(event) => changeDate(event.target.value)}>{recordDates.map((date) => (<option key={date} value={date}>{date}</option>))}</select>
                                </div>
                            </td>
                            <td>
                                <div className="flex align-middle">
                                    <button className="m-1 py-1 px-2 bg-[#ffae00] text-[#fff]" style={{borderRadius:".5em"}} onClick={() => dateInputRef.current.showPicker()}>新增日期</button>
                                    <input type="date" max={today} ref={dateInputRef} className=" invisible" onChange={(event) => addNewDate(event.target.value)}></input><br/>
                                </div>
                            </td>
                        </tr>
                    </table>
                    <div className="flex flex-wrap justify-center">
                    <table className="w-4/5 border-l-4 border-l-[#ffd500] text-center">
                        <thead>
                            <tr className="text-center bg-[#bfbfbf]">
                                <td className="w-1/12 bg-[#D9EFEC] py-6"></td>
                                <td className="rounded-l-lg">測驗項目</td>
                                <td className="px-4 py-2">OD</td>
                                <td className="px-4 py-2 rounded-r-lg">OS</td>
                            </tr>
                        </thead>
                        {outletDatas && Object.keys(outletDatas).length>0 ?
                            <tbody>
                                {displayRecord(outletDatas)}
                                <AddPDF record_id={outletDatas.record_id} onlyForRead={false} ref={PDFRef}></AddPDF>
                            </tbody>
                        : <div></div>}
                        <tr>
                            <td colSpan={2}></td>
                            <td colSpan={3} className="pt-2">
                                <div className="flex justify-between">
                                    <button className="py-2 px-4 bg-[#399b25] text-[#fff]" style={{borderRadius:".5em"}} onClick={(event) => sendDataToServer()}>上傳所有紀錄</button>  
                                    <button className="py-2 px-4 bg-[#7231ff] text-[#fff]" style={{borderRadius:".5em"}} onClick={() => recoverToday()}>還原本日資料</button>
                                    <button className="py-2 px-4 bg-[#ff3c3c] text-[#fff]" style={{borderRadius:".5em"}} onClick={(event) => deleteToday()}>清空本日紀錄</button> 
                                </div>
                            </td>
                        </tr>
                    </table>
                    </div>
                </>
            }
        </div>
    )
}

export default AddExamineRecord;